import { render, staticRenderFns } from "./simulador-comparativo.vue?vue&type=template&id=7d62e130&scoped=true&"
import script from "./simulador-comparativo.vue?vue&type=script&lang=js&"
export * from "./simulador-comparativo.vue?vue&type=script&lang=js&"
import style0 from "./simulador-comparativo.vue?vue&type=style&index=0&id=7d62e130&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d62e130",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VScaleTransition } from 'vuetify/lib/components/transitions';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCheckbox,VDivider,VEditDialog,VMenu,VScaleTransition,VSpacer,VTextField,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d62e130')) {
      api.createRecord('7d62e130', component.options)
    } else {
      api.reload('7d62e130', component.options)
    }
    module.hot.accept("./simulador-comparativo.vue?vue&type=template&id=7d62e130&scoped=true&", function () {
      api.rerender('7d62e130', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/simulador-comparativo.vue"
export default component.exports